import { defineAdsController } from "./defineAds";
import { fetchHeaderBids } from "./callAds";
async function adController() {
  window.drupalSettings.ads.log = [];

  let adDefinitions:AdDefinition;
  try {
    adDefinitions = await defineAdsController();
  } catch(e) {
    window.drupalSettings.ads.log.push(e);
  }
  if (adDefinitions) {
    fetchHeaderBids(adDefinitions.amazonSlots, adDefinitions.prebidSlots, []);
  }
}

// We need this event listener to wait for Drupal settings.
document.addEventListener("DOMContentLoaded", function() {
  adController();
});

